import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import {
  convertToCurrencyFormat,
  getSerialFromBarcode,
  stockUnitOfMeasureOptions,
  isReadOnlyUser,
} from "../../shared/utility";
import AuditActionLink from "../../components/audit/AuditActionLink";

export default function CreditReturnCartonsTable(props) {
  const { askDeleteCarton, closed, values } = props;
  const isReadOnly = isReadOnlyUser();

  function bodyActions(rowData) {
    return (
      <div className="flex items-center">
        {rowData.deleted_at ? (
          <p className="text-black font-bold text-lg">DELETED</p>
        ) : (
          !isReadOnly && !closed && (
            <button
              onClick={() => {
                askDeleteCarton(rowData.id);
              }}
              className="rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
            >
              Delete
            </button>
          )
        )}
        {rowData.id ? (
          <AuditActionLink
            slug="credit-return-item"
            id={rowData.id}
            name={rowData.product_name || rowData.lot_number}
          />
        ) : null}
      </div>
    );
  }

  const productDetailsBody = (rowData) => {
    const returnType = rowData.orders_source_item_id ? "From order" : "Manual";

    return (
      <p>
        <span className="text-gray-900 font-semibold">
          {rowData.product_name}
        </span>
        <br />
        <span className="text-gray-700">PLU:{rowData.plu}</span>
        <br />
        <span className="text-xs text-gray-500">{returnType}</span>
      </p>
    );
  };

  const unitPriceBody = (rowData) => {
    const stockUofM = stockUnitOfMeasureOptions.find(
      (opt) => opt.value === rowData.selling_unit_of_measure,
    )?.label;
    return (
      <p>
        {convertToCurrencyFormat(rowData.unit_price)}/{stockUofM}
      </p>
    );
  };

  const totalPriceBody = (rowData) => {
    return <p>{convertToCurrencyFormat(rowData.total_price)}</p>;
  };

  const totalShippedWeightParent = (rowData) => {
    return (
      <div>
        <p>{rowData.weight_in_kg}kg</p>
        <p>{rowData.weight_in_lbs}lbs</p>
        <p>{rowData.piece_count} pieces</p>
      </div>
    );
  };

  const barcodeBody = (rowData) => {
    return <p>{getSerialFromBarcode(rowData.barcode)}</p>;
  };

  return (
    <div className="">
      <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <div className="overflow-hidden">
            <DataTable
              value={values.items}
              dataKey="id"
              tableClassName="min-w-full bg-white divide-y divide-gray-300 cr-items-table-parent"
              cellClassName="p-2 bg-white border-1-bottom-gray text-sm"
            >
              <Column header="Product" body={productDetailsBody} />
              <Column header="Barcode" body={barcodeBody} />
              <Column header="Lot Number" field="lot_number" />

              <Column
                header="Amount"
                body={totalShippedWeightParent}
                style={{ textAlign: "right" }}
              />

              <Column
                header="Unit Price"
                field="unit_price"
                style={{ textAlign: "right" }}
                body={unitPriceBody}
              />

              <Column
                header="Total Price"
                field="total_price"
                style={{ textAlign: "right" }}
                body={totalPriceBody}
              />

              <Column header="" body={bodyActions} />
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  );
}
